import { useState , useEffect } from 'react'
import SearchProducts from 'newComponents/SearchProducts';
import ResultsFilter from 'newComponents/Results';
import ViewsFilter from 'newComponents/ViewsFilter';
import { priceFormat } from 'util/prices';
import OrderFilter from 'newComponents/OrdersFilter';
import styles from './styles.module.sass';


const ContentSearch = (props) => {

    const {
        setSearchWord,
        setActiveView,
        resultsSearch,
        setOrder
    } = props

    const [cantResults, setCantResults] = useState()

    useEffect(() => {
        if(resultsSearch){
            if( !Number.isNaN( Number(resultsSearch?.totalResults) )){
                setCantResults( Number(resultsSearch?.totalResults) )
            }
        }
    },[resultsSearch])
    

    return(
        <div className={styles?.contTitle}>
            <h1>¿Qué deseas que te regalen?</h1>
            <div className={styles?.contParamsViews}>
                <SearchProducts setSearchWord={setSearchWord} />
                <div className={styles?.contViewOrder}>
                    <ResultsFilter cantResults={cantResults && priceFormat( cantResults )} />
                    <ViewsFilter setActiveView={setActiveView} />
                    <OrderFilter setOrder={setOrder} />
                </div>
            </div>
        </div>
    )
}

export default ContentSearch